"use strict";
// Copyright © Veeam Software Group GmbH
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createOptionContainerRenderer = void 0;
const react_1 = __importDefault(require("react"));
const View_1 = require("../../View");
const OptionRoot_1 = require("../OptionRoot");
const getBackgroundView = ({ active, hovered, disabled }) => {
    if (disabled) {
        return View_1.VIEW_BG_VIEW.normal;
    }
    if (active) {
        return View_1.VIEW_BG_VIEW.highlightDark;
    }
    if (hovered) {
        return View_1.VIEW_BG_VIEW.highlight;
    }
    return View_1.VIEW_BG_VIEW.normal;
};
function createOptionContainerRenderer() {
    return function optionContainerRenderer(_a) {
        var { control, content, active, hovered, disabled, style } = _a, rest = __rest(_a, ["control", "content", "active", "hovered", "disabled", "style"]);
        const { ref } = control, controlProps = __rest(control, ["ref"]);
        return (react_1.default.createElement(OptionRoot_1.OptionRoot, Object.assign({ style: style, backgroundView: getBackgroundView({
                active,
                hovered,
                disabled
            }), disabled: disabled, contentMod: View_1.VIEW_CONTENT_MOD.fill }, controlProps, { ref: ref, testId: rest['data-selector-id'] }), content));
    };
}
exports.createOptionContainerRenderer = createOptionContainerRenderer;
//# sourceMappingURL=optionContainerRenderer.js.map